var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGi5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.16 3.8C17.07 3.34 16.66 3 16.18 3H1.82C1.34 3 0.93 3.34 0.84 3.8L0 8V9C0 9.55 0.45 10 1 10V15C1 15.55 1.45 16 2 16H10C10.55 16 11 15.55 11 15V10H15V15C15 15.55 15.45 16 16 16C16.55 16 17 15.55 17 15V10C17.55 10 18 9.55 18 9V8L17.16 3.8ZM9 14H3V10H9V14ZM2 2H16C16.55 2 17 1.55 17 1C17 0.45 16.55 0 16 0H2C1.45 0 1 0.45 1 1C1 1.55 1.45 2 2 2Z",
    fill: "#292929",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi5);
export default __webpack_public_path__ + "static/media/gi-5.8ec8a554d99f3df459ab052c87288505.svg";
export { ForwardRef as ReactComponent };